export default function AboutSection() {
  return (
    <section id="about" className="w-full py-14 md:py-20 px-4 md:px-6 bg-background-50">
      <div className="max-w-[1440px] mx-auto">
        <div className="flex flex-col lg:flex-row items-center gap-8 lg:gap-16">
          <div className="flex-1">
            <div className="relative rounded-2xl overflow-hidden aspect-video bg-secondary-200">
              <img
                src="https://readdy.ai/api/search-image?query=Cozy%20home%20living%20room%20with%20large%20TV%20screen%20displaying%20movie%20scene%2C%20warm%20ambient%20lighting%20from%20table%20lamp%2C%20comfortable%20sofa%20with%20cushions%2C%20popcorn%20bowl%20on%20coffee%20table%2C%20modern%20minimal%20interior%2C%20golden%20hour%20warm%20light%20through%20window%2C%20cozy%20atmosphere&width=800&height=450&seq=about-cinema-2026-01&orientation=landscape"
                alt="花生影院品牌介绍 - 舒适的家庭观影场景"
                className="w-full h-full object-cover"
                onError={(e) => {
                  const target = e.currentTarget;
                  target.style.display = 'none';
                }}
              />
            </div>
          </div>

          <div className="flex-1 text-center lg:text-left">
            <h2 className="text-2xl md:text-3xl font-heading text-foreground-950 mb-4">
              关于花生影院
            </h2>
            <p className="text-sm md:text-base text-foreground-600 leading-relaxed mb-4">
              花生影院成立于2024年，致力于为广大影迷打造最全面、最便捷的电影在线观看平台。我们深知每一位观众对好电影的渴望，因此从电影大全的资源整合到播放体验的每一个细节，都倾注了团队的极大热情。
            </p>
            <p className="text-sm md:text-base text-foreground-600 leading-relaxed mb-4">
              平台目前已收录超过3.2万部高清电影资源，涵盖动作、喜剧、科幻、悬疑、恐怖、爱情、动画等全品类。每日更新最新片源，确保你永远不会错过任何一部热门新片。我们的技术团队采用多线CDN智能分发架构，让高清在线观看真正做到不缓冲、不卡顿。
            </p>
            <p className="text-sm md:text-base text-foreground-600 leading-relaxed">
              花生影院的电影排行榜由真实用户观看数据驱动，结合专业编辑的人工甄选，帮助你在海量电影资源中快速发现值得一看的好片子。无论你是资深影迷还是偶尔观影的休闲用户，这里都有属于你的光影世界。
            </p>

            <div className="flex flex-wrap gap-4 mt-6 justify-center lg:justify-start">
              <div className="flex items-center gap-2 text-sm text-foreground-500">
                <i className="ri-checkbox-circle-fill text-primary-500"></i>
                <span>内容每日更新</span>
              </div>
              <div className="flex items-center gap-2 text-sm text-foreground-500">
                <i className="ri-checkbox-circle-fill text-primary-500"></i>
                <span>全高清画质</span>
              </div>
              <div className="flex items-center gap-2 text-sm text-foreground-500">
                <i className="ri-checkbox-circle-fill text-primary-500"></i>
                <span>多设备兼容</span>
              </div>
              <div className="flex items-center gap-2 text-sm text-foreground-500">
                <i className="ri-checkbox-circle-fill text-primary-500"></i>
                <span>无广告纯净观影</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}